module.exports = __webpack_public_path__ + "5d95d9e7f57c9de8580bf421105e7f12.png";